const { stringComparator } = require('./utils/comparators');

module.exports = stringComparator(
  'prefix',
  (param, prefix) => param.startsWith(prefix)
);
